// extracted by mini-css-extract-plugin
export var label = "_i4-2";
export var slideContainer = "_i4-0";
export var slider = "_i4-1";